import { Tag } from '@contrast-security-inc/base-types'
import { LibrarySCA } from './libraries-interfaces'
import { Library } from './ui-interfaces'

export const isPrivateLibrary = (library: Library | LibrarySCA) =>
  !!(library.custom || library.privateLibrary)

/**
 * Display the combined group & name for Go libraries.
 * This is specific to the CLI-Grid as the response separates group and name.
 * @param library SCA Library object
 * @returns Go library name
 */
export const getGoLibraryName = (library: LibrarySCA) => {
  const getSeparator = () =>
    library.groupName.length > 0 && library.groupName.endsWith('/') ? '' : '/'

  return library.groupName
    ? `${library.groupName}${getSeparator()}${library.artifactName}`
    : library.artifactName
}

/** Convert a list of strings to a list of Tag objects */
export const toTags = (tags: string[]) =>
  tags.map((tag) => ({ id: tag, name: tag }))

/** Convert a list of Tag objects to a list of strings */
export const fromTags = (tags: Tag[]) => tags.map((tag) => tag.id)
